import {
  Text as MantineText,
  type TextProps as MantineTextProps,
} from "@mantine/core";
import type { CoreComponentProps, PolymorphicProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type TextProps = CoreComponentProps<MantineTextProps, 'div'> &
  PolymorphicProps;

export function Text({ testId, view = "all", ...rest }: TextProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantineText data-testid={testId} {...(rest as MantineTextProps)} />;
}
